import smoothscroll from "smoothscroll-polyfill";
import { updateConfiguration } from "@wel-ui/utility-configuration";

updateConfiguration({
  styles: {
    namespace: "trtaSolutionFinder"
  }
});

// Support for window.scroll API (https://developer.mozilla.org/en-US/docs/Web/API/Window/scroll)
smoothscroll.polyfill();



// WEBPACK FOOTER //
// ./js/configure.js